export default {
  all: [],
  one: {},
  stats: [],
  generatedExternal: [],
};
